import { PropsWithChildren, useEffect } from 'react';
import {
  useApi,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { getBanner } from '../../api/banner';
import { isSkilljarHost } from '../../utilities/isSkilljarHost';
import { Header } from '../header/Header';
import { Sidebar } from '../sidebar/Sidebar';
import { Footer } from '../footer/Footer';
import { SkilljarRoot } from '../skilljar-signup/SkilljarRoot';

export const Root = ({ children }: PropsWithChildren) => {
  const discovery = useApi(discoveryApiRef);
  const identity = useApi(identityApiRef);

  const banner = useQuery({
    queryKey: ['banner'],
    queryFn: () => getBanner(discovery, identity),
    enabled: !isSkilljarHost,
  });

  const bannerContent = banner.data;

  useEffect(() => {
    if (bannerContent && bannerContent !== 'none') {
      enqueueSnackbar(bannerContent, {
        variant: 'banner',
        persist: true,
        preventDuplicate: true,
      });
    }
  }, [bannerContent]);

  if (isSkilljarHost) return <SkilljarRoot>{children}</SkilljarRoot>;

  return (
    <>
      <Header />
      <Stack direction="row" flex={1}>
        <Sidebar />
        <Stack flex={1} bgcolor="white">
          <Stack flex={1}>{children}</Stack>
          <Footer />
        </Stack>
      </Stack>
    </>
  );
};
